import { faker } from '@faker-js/faker';
// import { arrayRandom } from '../helpers';

let deviceCount = 0;
// let applianceCount = 0;
// let appliancesCreated = [null];
let id = 1;
const types = [
  'MobileCamera',
  'StaticCamera',
  'Other',
];
const connectionTypes = [
  'Radio',
  'Cellular',
  'Fiber',
];

export function createMockDevice() {
  const streamCount = faker.number.int({ min: 5, max: 8 });
  const type = types[faker.number.int({ min: 0, max: 2 })];
  const device = {
    name: `DEVICE_${deviceCount.toString().padStart(5, '0')}`,
    id: faker.database.mongodbObjectId(),
    description: faker.lorem.lines({ min: 1, max: 5 }),
    type,
    connection_type: type !== 'Other'
      ? connectionTypes[faker.number.int({ min: 0, max: 2 })]
      : null,
    network_address: faker.internet.ipv4(),
    latitude: faker.location.latitude(),
    longitude: faker.location.longitude(),
    elevation: null,
    problem_camera: false,
    metadata: [],
    username: null,
    password: null,
    sources: [],
    streams: Array.from({ length: streamCount }, (_, i) => ({
      id: faker.database.mongodbObjectId(),
      name: `Stream ${i + 1}`,
      description: faker.lorem.sentence(),
      online: faker.datatype.boolean(),
      clsps_address: `clsps://stream-${i + 1}.example.com/live`,
      source: { id: faker.database.mongodbObjectId(), name: `Source ${i + 1}` },
      zone: { id: faker.database.mongodbObjectId(), name: `Zone ${i + 1}` },
      appliance: {
        id: faker.database.mongodbObjectId(),
        name: `Appliance ${i + 1}`,
        public_address: faker.internet.ipv4(),
        management_address: faker.internet.ipv4(),
      },
      pull_on_request: false,
      use_interleaved_rtsp_transport: false,
    })),
  };
  id++;
  deviceCount++;
  // applianceCount++;
  return device;
}